<template>
  <div>
    <HeaderBreadcrumbs :items="[
      { label: 'Brand',
       to: '/ax/items/brand-ax'
      },  
      { label: 'Edit' }
    ]" title="Edit Brand" />
    <div class="flex-col w-full bg-white shadow-sm rounded-lg px-4 py-3">
      <div class="w-1/2">
        <h4 class="font-bold text-xl leading-7 mb-4 block">Edit Brand</h4>
        <div class="mb-3">
          <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
            Item Name
          </label>
          <input id="basePrice" type="text" v-model="name" placeholder="Enter Item Name"
            class="w-full rounded-md px-4 border py-2.5 text-sm focus:outline-none focus:ring-2" />
        </div>
        <div class="mb-3 mr-2">
          <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
          Brand
          </label>
          <multiselect
                v-model="brand"
                label="name"
                track-by="name"
                placeholder="Select Item Name"
                open-direction="bottom"
                required="required"
                :options="brandSearchOptions"
                :searchable="true"
                :loading="isBrandSearch"
                :close-on-select="true"
                :options-limit="10"
                :multiple="false"
                :allow-empty="false"
                @search-change="brandFind"
              >
              </multiselect>
        </div>
        <div class="mb-3">
          <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
            Base Price
          </label>
          <input id="basePrice" type="number" min="0" v-model="basePrice" placeholder="Enter Base Price"
            class="w-full rounded-md px-4 border py-2.5 text-sm focus:outline-none focus:ring-2" />
        </div>
        <div class="mb-3">
          <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
            Subscription ID AX
          </label>
          <input id="subsIdAx" type="number" min="0" v-model="subsIdAx" placeholder="Enter Single ID AX"
            class="w-full rounded-md px-4 border py-2.5 text-sm focus:outline-none focus:ring-2" />
        </div>  
        <div class="mt-3 mr-1.5">
          <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
            Vendor
          </label>
          <multiselect v-model="vendor" label="name" track-by="name" placeholder="Select Vendor"
            open-direction="bottom" :options="items_vendor" :searchable="true" :loading="isLoadingSearch"
            :close-on-select="true" @search-change="findVendorName" @input="getVendorAx">
            <span slot="noResult">
              Oops! No elements found. Consider changing the search query.
            </span>
          </multiselect>
        </div>
        <div class="mt-3">
          <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
            Vendor ID AX
          </label>
          <input id="basePrice" type="text" v-model="vendor_id_ax" placeholder="Vendor ID AX"
            class="w-full rounded-md px-4 border py-2.5 text-sm focus:outline-none focus:ring-2" />
        </div>
        <div class=" mt-4 mb-3 mr-0 flex justify-start">
          <button @click="editBrandAx()" class="bg-blue-600 text-white px-4 py-2 rounded-lg mr-3">Save</button>
          <button type="reset" class="bg-whit text-gray-500 border px-4 py-2 rounded-lg">
            <router-link class="text-gray-500 no-underline hover:no-underline hover:text-gray-500" size="sm"
            :to="{
              name: brandItemAx.name,
            }" 
            >
              Cancel
            </router-link>
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- <b-overlay :show="isLoading" rounded="sm">
    <div class="card mt-2">
      <div class="card-header text-center bg-primary">
        <h3>Edit Brand AX</h3>
      </div>
      <div class="card-body">
        <h5>
          <router-link
            :to="{
              name: brandItemAx.name,
            }"
          >
            <span class="badge badge-primary"
              ><i class="fa fa-rotate-left mr-1"></i>Back</span
            >
          </router-link>
        </h5>
        <div class="row">
          <div class="col-sm-3"></div>
          <div class="col-sm-6">
            <div class="form-group">
              <label for="organization"
                >Name<span class="text-danger">*</span> :</label
              >
              <input
                v-model="name"
                type="text"
                class="form-control"
                placeholder="type item name..."
              />
            </div>

            <div class="form-group">
              <label for="organization"
                >Brand<span class="text-danger">*</span> :
              </label>
              <multiselect
                v-model="brand"
                label="name"
                track-by="name"
                placeholder="select brand..."
                open-direction="bottom"
                required="required"
                :options="brandSearchOptions"
                :searchable="true"
                :loading="isBrandSearch"
                :close-on-select="true"
                :options-limit="10"
                :multiple="false"
                :allow-empty="false"
                @search-change="brandFind"
              >
              </multiselect>
            </div>

            <div class="form-group">
              <label for="organization"
                >Base Price<span class="text-danger">*</span> :</label
              >
              <input
                v-model="basePrice"
                type="number"
                class="form-control"
                placeholder="49000"
              />
            </div>

            <div class="form-group">
              <label for="organization"
                >Subscription ID AX<span class="text-danger">*</span> :</label
              >
              <input
                v-model="subsIdAx"
                type="number"
                class="form-control"
                placeholder="528196376"
              />
            </div>

            <div class="form-group">
              <label for="organization"
                >Vendor<span class="text-danger">*</span> :</label
              >
              <multiselect
                v-model="vendor"
                label="name"
                track-by="name"
                placeholder="type to find vendor..."
                open-direction="bottom"
                :options="items_vendor"
                :searchable="true"
                :loading="isLoadingSearch"
                :close-on-select="true"
                @search-change="findVendorName"
                @input="getVendorAx"
              >
                <span slot="noResult">
                  Oops! No elements found. Consider changing the search query.
                </span>
              </multiselect>
            </div>

            <div class="form-group">
              <label>Vendor ID AX<span class="text-danger">*</span> : </label>
              <input
                v-model="vendor_id_ax"
                type="text"
                class="form-control"
                placeholder="V-000005276"
              />
            </div>

            <br /><br />
            <button
              type="submit"
              class="btn btn-primary btn-block"
              @click="editBrandAx()"
            >
              <i class="fa fa-pencil"></i>
              Update Brand AX
            </button>
          </div>
          <div class="col-sm-3"></div>
        </div>
      </div>
    </div>
  </b-overlay> -->
</template>
<script>
import { mapActions, mapState } from 'vuex';
import { brandItemAx } from '../../router/content';
import HeaderBreadcrumbs from '@/components/HeaderBreadcrumbs'
import {EventBus} from '../../event-bus'

export default {
  name: 'UpdateBrandAX',
  components: {
    HeaderBreadcrumbs
  },
  data() {
    return {
      brandItemAx,
      name: null,
      brand: [],
      brandSearchOptions: [],
      isBrandSearch: false,
      basePrice: '',
      subsIdAx: '',
      vendor: [],
      items_vendor: [],
      isLoadingSearch: false,
      vendor_id_ax: '',
    };
  },
  watch: {
    successMessage: function() {
      if (!this.successMessage) return;
   //   this.alertMsg(this.successMessage, 'success');
      EventBus.$emit('show-toast', {
            message:'Brand has been updated.',
            type: 'success',
          });
      this.$router.push('/ax/items/brand-ax');
    },
    errorMessage: function() {
      if (!this.errorMessage) return;
    //  this.alertMsg(this.errorMessage, 'error');
      EventBus.$emit('show-toast', {
            message:this.errorMessage,
            type: 'error',
          });
    },
    isError: function() {
      if (!this.isError) return;
      this.alertMsg('Ops. Something went wrong !', 'error');
    },
    item: function() {
      if (!this.item) return;
      this.getDataBrandAx();
    },

    $route: {
      immediate: true,
      handler(to) {
        document.title =
          to.meta.title ||
          'Edit Brand AX | Content Management System Ebooks Gramedia.com';
      },
    },
  },
  created: function() {
    const id = this.$route.params.id;
    this.fetchById(id);
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.brandAx.isLoading,
      isError: (state) => state.brandAx.isError,
      successMessage: (state) => state.brandAx.SuccessMessage,
      errorMessage: (state) => state.brandAx.ErrorMessage,
      item: (state) => state.brandAx.item,
      itemBrand: (state) => state.brands.items,
    }),
  },
  methods: {
    ...mapActions('brandAx', [
      'createBrandAx',
      'createBrandAx',
      'fetchById',
      'updateBrandAx',
    ]),
    ...mapActions('brands', ['searchBrands', 'fetchBrandsByid']),
    ...mapActions('vendors', ['findVendor', 'fetchVendorsById']),

    getDataBrandAx() {
      const item = this.item;
      this.name = item.name;
      this.basePrice = item.base_price;
      this.subsIdAx = item.subs_idax;
      this.vendor_id_ax = item.vendor_id_ax;
      this.getVendorById(item.vendor_id);
      this.getBrandById(item.brand_id);
    },

    brandFind(query) {
      if (!query) return;
      this.isBrandSearch = true;
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        let payload = {
          name: query,
          limit: 10,
        };
        this.searchBrands(payload)
          .then((response) => {
            this.brandSearchOptions = response.data.data.rows;
            this.isBrandSearch = false;
          })
          .catch(() => {
            this.isBrandSearch = false;
          });
      }, 600);
    },

    findVendorName(keyword) {
      if (keyword.length > 2) {
        this.isLoadingSearch = true;
        let payload = {
          q: keyword,
        };
        this.findVendor(payload)
          .then((resp) => {
            this.items_vendor = resp.data.data;
            this.isLoadingSearch = false;
          })
          .catch((err) => {
            this.isLoadingSearch = false;
            console.log(err);
          });
      }
    },

    getVendorAx() {
      this.fetchVendorsById(this.vendor).then((res) => {
        this.vendor_id_ax = res.data?.data?.sync_vendor?.vendor_id_ax;
      });
    },

    editBrandAx() {
      const payload = {
        id: this.$route.params.id,
        name: this.name,
        brandId: parseInt(this.brand?.id, 10),
        basePrice: parseInt(this.basePrice, 10),
        subs_Idax: this.subsIdAx,
        vendorId: this.vendor ? parseInt(this.vendor.id) : null,
        vendorName: this.vendor ? this.vendor.name : null,
        vendor_Idax: this.vendor_id_ax,
      };
      this.updateBrandAx(payload);
    },

    getVendorById(id) {
      return this.fetchVendorsById({ id }).then(
        (res) => (this.vendor = res.data.data),
      );
    },

    getBrandById(id) {
      return this.fetchBrandsByid({ id }).then((res) => (this.brand = res[0]));
    },

    alertMsg(msg, type) {
      this.$swal({
        icon: type,
        toast: true,
        position: 'top-end',
        title: msg,
        timer: 10000,
        text: this.message,
      });
    },
  },
};
</script>
